import { createFileRoute } from "@tanstack/react-router";

import { SuppliersListPage } from "@/modules/suppliers/pages/SuppliersList.page";

export const Route = createFileRoute("/__authed/m/suppliers")({
	component: SuppliersListPage,
});
